export default "__VITE_ASSET__a4e14b75__"